<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3" y="11" width="18" height="2" rx="1" fill="#5C5C5C"/>
<rect x="2.59961" y="12" width="12" height="2" rx="1" transform="rotate(-45 2.59961 12)" fill="#5C5C5C"/>
<rect width="12" height="2" rx="1" transform="matrix(0.707107 0.707107 0.707107 -0.707107 2.59961 12)" fill="#5C5C5C"/>
</svg>
